import React from "react";

import ModalWrapper from "../../../../../../components/Modals/ModalWrapper";
import XMarkIcon from "../../../../../../resources/route-builder/x-mark.svg";
import { useRouteBuilder } from "../../context/RouteBuilderContext";
import SetupForm from "./SetupForm";

export default function SetupRouteBuilderModal({
  onClose,
}: {
  onClose: () => void;
}) {
  const { isBusy } = useRouteBuilder();

  const close = () => {
    if (!isBusy) onClose();
  };

  return (
    <ModalWrapper clickOff={close} bgOpacity="40" zIndexClass="z-[60]">
      <div
        className="relative z-50 flex h-[min(50rem,90dvh)] w-[calc(100vw-2rem)] max-w-[47rem] flex-col overflow-hidden rounded-2xl border border-slate-200 bg-white shadow-xl"
        data-testid="route-builder-setup-modal"
        role="dialog"
        aria-modal="true"
        aria-labelledby="route-builder-setup-title"
        onClick={(event) => event.stopPropagation()}
      >
        <div className="absolute right-3 top-3 z-10 flex items-center gap-2">
          {isBusy ? (
            <span className="text-xs font-medium text-sky-700">Loading...</span>
          ) : null}
          <button
            type="button"
            data-testid="route-builder-setup-close"
            aria-label="Close configuration"
            disabled={isBusy}
            className="rounded-lg p-1.5 text-slate-500 hover:bg-slate-100 hover:text-slate-800 disabled:opacity-50"
            onClick={close}
          >
            <img src={XMarkIcon} alt="" className="h-5 w-5" aria-hidden />
          </button>
        </div>
        <div className="relative flex min-h-0 flex-1 flex-col">
          <SetupForm />
        </div>
      </div>
    </ModalWrapper>
  );
}
